import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CREATE_FEEDBACK } from '../mutations';
import { FeedbackOutput, FeedbackInput, FeedbackQuery } from '../gql/graphql';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GET_FEEDBACKS } from '../queries/useFeedbackGenerate';

export const useFindFeedbacks = (query: FeedbackQuery) => {
  return useQuery<FeedbackOutput[], Error, FeedbackOutput[]>({
    queryKey: ['feedback', query],
    queryFn: async () => {
      const { findFeedbacks } = await graphqlFetch<
        { findFeedbacks: FeedbackOutput[] },
        { query: FeedbackQuery }
      >(GET_FEEDBACKS, { query });
      return findFeedbacks;
    },
  });
};

export const useCreateFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation<FeedbackOutput, Error, FeedbackInput>({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        { createFeedback: FeedbackOutput },
        { input: FeedbackInput }
      >(CREATE_FEEDBACK, { input });
      return data.createFeedback;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['feedback'],
      }),
  });
};
